import { ProductType } from '@/helpers/fetchTariffs/types';

const productTypeDictionary: Record<ProductType, string> = {
  power: 'strom',
  gas: 'gas',
};

export default productTypeDictionary;
